import React from 'react';
import { Link, useHistory } from 'react-router-dom';

function Header({ user, onLogout }) {
  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem('token');
    onLogout();
    history.push('/login');
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/" className="header-logos" style={{ textDecoration: 'none', color: 'inherit' }}>
          <img
            src="/logos/tvu-logo.png"
            alt="TV Uster"
            className="header-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <img
            src="/logos/red-dragons-logo.png"
            alt="Red Dragons"
            className="header-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h1 className="header-title">TVU Red Dragons Hilf-MIT</h1>
        </Link>

        <div className="header-nav">
          {user && (
            <>
              <Link to="/" style={{ textDecoration: 'none', color: 'white', fontWeight: '500' }}>
                Events
              </Link>
              {(user.is_team_admin || user.is_admin) && (
                <Link to="/team-admin" style={{ textDecoration: 'none', color: 'white', fontWeight: '500' }}>
                  Team Admin
                </Link>
              )}
              {user.is_admin && (
                <Link to="/admin" style={{ textDecoration: 'none', color: 'white', fontWeight: '500' }}>
                  Admin
                </Link>
              )}
              <Link to="/profil" style={{ textDecoration: 'none', color: 'white', fontSize: '0.9rem', opacity: 0.9 }}>
                {user.first_name && user.last_name
                  ? `${user.first_name} ${user.last_name}`
                  : user.email}
              </Link>
              <button
                onClick={handleLogout}
                style={{
                  padding: '0.5rem 1rem',
                  fontSize: '0.9rem',
                  backgroundColor: 'white',
                  color: '#C62828',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                Abmelden
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
